@if (routeSummary.length >0) {
  <div id="altRouteSummary" class="route-summary-list">
    <div class="altRouteRow" data-altroute="1">
      @for (item of routeSummary; track trackByFn(indx); let indx = $index) {
        <div (mouseover)="onMouseOver(item, indx)" (mouseout)="onMouseOut(item, indx)">
          <div class="routeSummaryRow">
            <label class="radio-button">
              <input class="viaInput" type="radio" name="routeSummary" [checked]="summaryData.SelectedAltRoute === indx"
                (focus)="onFocusOption(indx)"  (blur) = "onBlurOption(indx)"
                (change)="onChangeSelectedRoute(item, indx)" />
                <span class="circle" id="routeOption{{indx}}"></span>
                <span class="label" [innerHTML]="getViaRoute(item)"></span>
                <span class="circle"></span>
                @if (indx === summaryData.SelectedAltRoute ? true : false) {
                  <span class="showInKM label"
                  (click)="onShowInMileKM(item, summaryData.SelectedAltRoute)" (keyup.enter)="onShowInMileKM(item, summaryData.SelectedAltRoute)" tabindex="0">{{getToogleButtonLabel(item)}}</span>
                }</label>
              </div>
            </div>
          }
        </div>
        <hr />
      </div>
    }

    @if (isRouteDirectionErrorFlag) {
      <div class="invalid_location_error">
        Route not available.
      </div>
    }